import { ListManager, PageHeader, Styles } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import { REGION } from '@/lib/enums'
import reports from '@/services/api/reports'
import React from 'react'
import FilterClinicalCares from '../../components/FilterClinicalCares'

function ClinicalCaresByRegion({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(reports.clinicalCaresByRegion, query)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Atendimentos clínicos por região"
        subtitle="Mostra a quantidade de atendimentos clínicos solicitados por região"
        icon="fas fa-map"
        rightAction={() => <FilterClinicalCares />}
      />
      <ListManager count={data?.length || 0} loading={loading} error={error}>
        {data?.length > 0 && (
          <small>
            <table className="table">
              <thead>
                <tr>
                  <th>Região</th>
                  <th>Tipo</th>
                  <th className="text-right">Quantidade</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item?.regionId}>
                    <td>
                      {item?.regionName}
                      {Boolean(item?.regionDescription) && (
                        <div><small>{item.regionDescription}</small></div>
                      )}
                    </td>
                    <td>{REGION.type.t(item?.regionType)}</td>
                    <td className="text-right">{item?.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </small>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default ClinicalCaresByRegion
